import { useCallback } from 'react'
import { useSnackbarContext, SNACKBAR_TOP_RIGHT } from './SnackbarContext'

// Returns `copy(value, label)`: writes `value` to the clipboard and confirms with a snackbar ("{label} copied" —
// "Copied" without a label), or reports the failure. The one place the copy buttons share, so every copy action
// acknowledges itself the same way.

export const useCopyToClipboard = () => {
  const { showSnackbar } = useSnackbarContext() || {}

  return useCallback(async (value, label) => {
    try {
      await navigator.clipboard.writeText(value || '')
      showSnackbar && showSnackbar(label ? `${label} copied` : 'Copied', { variant: 'success', autoHideDuration: 2000, anchorOrigin: SNACKBAR_TOP_RIGHT })
    } catch {
      showSnackbar && showSnackbar('Failed to copy. Your browser may not support this.', { variant: 'error', anchorOrigin: SNACKBAR_TOP_RIGHT })
    }
  }, [showSnackbar])
}
